export default "__VITE_ASSET__01352fa9__$_?component__"